
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import useI18n from '@/mixins/useI18n';
import {
  computed, defineComponent, toRefs, Ref, ref, PropType
} from 'vue';
import ByteCookieIcon from '@/components/svg/logo/logo-circles-only.svg?inline';
import Chevron from '@/components/svg-components/Chevron.vue';
import { RawLocation } from 'vue-router';

import { BlogEntry } from '../models/Blog';
import getBlogImageSrc from '../utils/blogImage';

export default defineComponent({
  components: {
    ByteCookieIcon,
    Chevron
  },
  props: {
    entry: { type: Object as () => BlogEntry, required: true },
    type: {
      type: String,
      required: true
    },
    positionOne: {
      type: Boolean,
      default: true
    },
    isDashboard: {
      type: Boolean,
      default: false
    },
    hideAuthor: {
      type: Boolean,
      default: false
    },
    hideVotes: {
      type: Boolean,
      default: false
    },
    hideDashboardHeader: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: '/blog'
    },
    publicAudienceTags: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  setup(props) {
    const { t } = useI18n();
    const { entry } = toRefs(props);
    const { getFormattedTimeByAge } = useFormattedDateTime();
    const lastUpdated = computed(() => getFormattedTimeByAge(props.entry?.lastUpdated));

    const articleType = computed<string>(() => {
      switch (props.type) {
        case 'BC_NEWS':
          return 'news';
        case 'HELP_ARTICLE':
          return 'wiki';
        default:
          return 'articles';
      }
    });
    const linkToBlog: Ref<RawLocation> = ref({ name: 'blog' });
    const featureBlogLink = computed(() => `${props.basePath}/${articleType.value}/${entry.value.externalId}`);
    const showPublicAudienceTags = computed(() => props.basePath === '/pblog' && props.publicAudienceTags.length > 0);
    const getPublicAudienceTagClass = (tag: string) => (tag === 'Freelancer' ? 'freelancer' : 'auftraggeber');

    const titleImageSrc = computed(() => getBlogImageSrc(entry.value.titleImage, entry.value.titleImageType));

    return {
      t,
      linkToBlog,
      featureBlogLink,
      titleImageSrc,
      lastUpdated,
      articleType,
      getPublicAudienceTagClass,
      showPublicAudienceTags,
    };
  }
});
